import { gql } from '@apollo/client';

export const DELETE_SITE_MUTATION = gql`
  mutation DeleteSiteMutation($input: DeleteSiteInput!) {
    deleteSite(input: $input) {
      ... on DeleteSiteSuccess {
        result
        targetSiteId
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
